import React from 'react';
import { List, ListItem, ListItemText, CircularProgress } from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/styles';
import { useQuery } from 'react-admin';
import { GET } from 'services/data/rest';

const styles = (theme) => {
  return createStyles({
    title: {
      margin: '0',
    },
    listItem: {
      color: theme.palette.primary.main,
      padding: '0rem 0',
    },
  });
};

const UpsAgreements = (props) => {
  const { classes, language } = props;
  const {
    data: agreements,
    loading,
    error,
  } = useQuery({ type: GET, resource: 'upsAgreemets', payload: {} });

  const localizedAgreement = React.useMemo(() => {
    if (!agreements) return null;

    return agreements[language] || agreements.en;
  }, [agreements, language]);

  if (loading || !agreements) {
    return <CircularProgress />;
  }

  if (error) {
    return <p>Oops... something was going wrong</p>;
  }

  return (
    <>
      <p className={classes.title}>
        <strong>{localizedAgreement?.confirmation}</strong>
      </p>
      <List>
        {localizedAgreement?.links?.map((link, index) => (
          <ListItem
            key={index}
            className={classes.listItem}
            component="a"
            target="_blank"
            href={link.url}>
            <ListItemText color="primary" primary={link.name} />
          </ListItem>
        ))}
      </List>
    </>
  );
};

export default withStyles(styles)(UpsAgreements);
